import React from 'react'

export default ({ node }) => <div>{node.extras.reason}</div>



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Reject/RejectDisplay.jsx